export const Games = (props) => {
  return (
    <div>
      Games
    </div>
  )
}